"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDateInShiftTuple = exports.dateToTimeString = exports.shiftToDateTuple = exports.convertToUTC = void 0;
const date_fns_tz_1 = require("date-fns-tz");
const libs_utils_1 = require("@hotelplan/libs.utils");
const getTimeWithOffset = (time, tz) => {
    const parts = time.split(':');
    const timeZone = [`${tz[0]}1`, tz.slice(1, 3), tz.slice(3, 5)].map(Number);
    const hrs = Number(parts[0]) - timeZone[0] * timeZone[1];
    const minutes = Number(parts[1]) - timeZone[0] * timeZone[2];
    return 1000 * (60 * (hrs * 60 + minutes));
};
const timeFromDateToMs = (d) => getTimeWithOffset(`${d.getUTCHours()}:${d.getUTCMinutes()}`, '+0000');
const getUTCMidnight = (d) => new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()).getTime();
const convertToUTC = (date, time, timezone) => {
    const utcMidnight = getUTCMidnight(date);
    if (time) {
        return new Date(utcMidnight + getTimeWithOffset(time, timezone));
    }
    return new Date(utcMidnight + timeFromDateToMs(date));
};
exports.convertToUTC = convertToUTC;
function timeStringToDate(time, tz, currentDate) {
    return (0, exports.convertToUTC)(currentDate, time, tz);
}
function shiftToDateTuple(shift, tz, currentDate) {
    return [
        timeStringToDate(shift.from, tz, currentDate),
        timeStringToDate(shift.to, tz, currentDate),
    ];
}
exports.shiftToDateTuple = shiftToDateTuple;
function dateToTimeString(dateTime, timeZone) {
    const zonedDateTime = (0, date_fns_tz_1.utcToZonedTime)(dateTime, timeZone);
    return (0, libs_utils_1.formatDate)(zonedDateTime, 'HH:mm');
}
exports.dateToTimeString = dateToTimeString;
function isDateInShiftTuple(date, [from, to]) {
    return from.getTime() <= date.getTime() && to.getTime() >= date.getTime();
}
exports.isDateInShiftTuple = isDateInShiftTuple;
//# sourceMappingURL=agencyOpeningTimes.utils.js.map